export default __webpack_public_path__ + "static/media/gif03.da32fa05.gif";